import { layout, moduleRoute } from '@src/helper/routes'
import type { GlobalContext } from '@src/types/GlobalContext'
import TsDeepCopy from 'ts-deepcopy'

export default (cntx: GlobalContext) => {
    const router = cntx.router
    const i18n = cntx.i18n
    // @ts-ignore
    const messages = { ...i18n.global.messages.value }
    for (const lang in messages) {
        const clone = messages[lang]
        if (clone['HumanResources']) {
            clone['Recruitment'] = TsDeepCopy(clone['HumanResources'])
            clone['Recruitment']['module'] =
                clone['HumanResources']['Recruitment'] ?? ''
        }
        i18n.global.setLocaleMessage(lang, clone)
    }
}
